import { axios } from '@Root/API'

export const createFieldMapping = payload => {
  return axios.post(`cognito-form-field-mappings`, payload)
}
